// This file is part of Moodle - http://moodle.org/
//
// Moodle is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// Moodle is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
//
// You should have received a copy of the GNU General Public License
// along with Moodle.  If not, see <http://www.gnu.org/licenses/>.

/**
 * Tiny Record RTC common values.
 *
 * @module      tiny_recordrtc/common
 * @copyright   2022, Stevani Andolo <stevani@hotmail.com.au>
 * @license     http://www.gnu.org/copyleft/gpl.html GNU GPL v3 or later
 */

export default {
    pluginName: 'tiny_recordrtc/plugin',
    component: 'tiny_recordrtc',
    audioButtonName: 'tiny_recordrtc_audio',
    videoButtonName: 'tiny_recordrtc_video',
    screenButtonName: 'tiny_recordrtc_screen',
    videoContextMenuName: 'tiny_recordrtc_video_context_menu',
};
